// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false
};

export const firebaseConfig = {
  apiKey: 'AIzaSyD7QY_Yn6Wnit5ifZ-iM4ONixuivBI6EX4',
  authDomain: 'wildrooster-c0ee9.firebaseapp.com',
  databaseURL: 'https://wildrooster-c0ee9.firebaseio.com',
  projectId: 'wildrooster-c0ee9',
  storageBucket: 'wildrooster-c0ee9.appspot.com',
  messagingSenderId: '11898942380',
  appId: '1:11898942380:web:462b2ef0bdbb7c772dc009',
  measurementId: 'G-SR9WF55G12'
};

export const config = {
  apiURL: 'https://app.grupobeh.com',
  // apiURL: 'https://sandbox.grupobeh.com',
  appID: 4
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
